import { STICKY_SIDEBAR_TOP_PX } from '@zillow/zrs-cms';
import React from 'react';

import { Post, Page } from '../../types/shared';
import B2BPostTemplate from '../B2BPostTemplate';
import B2CPostTemplate from '../B2CPostTemplate';
import PageTemplate from '../PageTemplate/PageTemplate';

import { ContentTemplateProps } from './ContentTemplate.types';

/**
 * ContentTemplate component that handles both B2B and B2C content.
 * It renders different templates based on the content type (post/page) and audience type (B2B/B2C).
 */
const ContentTemplate: React.FC<ContentTemplateProps> = ({
    post,
    contentType = 'B2C',
    knotchAccountId,
    hasStickyNav,
}) => {
    const PostTemplate =
        contentType === 'B2B' ? B2BPostTemplate : B2CPostTemplate;

    // Type guard to check if the post is a Post type
    const isPost = (content: Post | Page): content is Post => {
        return content.type === 'post' && 'readTime' in content;
    };

    // Type guard to check if the post is a Page type
    const isPage = (content: Post | Page): content is Page => {
        return content.type === 'page' && 'head' in content;
    };

    if (isPost(post)) {
        return (
            <PostTemplate
                post={post}
                knotchAccountId={knotchAccountId}
                stickySidebarTop={
                    hasStickyNav ? `${STICKY_SIDEBAR_TOP_PX}px` : undefined
                }
            />
        );
    }

    if (isPage(post)) {
        return <PageTemplate post={post} />;
    }

    // This should never happen if types are correct, but good to handle just in case
    throw new Error('Invalid post type');
};

export default ContentTemplate;
